import React from 'react';
import muvn_banner from '../muvn_banner.png'

const LandingPage = () =>
  <div className="landing-page">
    <img src={muvn_banner}/>
  </div>

export default LandingPage;